import { Box } from '@ouster/webviz-react-components';

import RecordingLookUpData from '../../components/adminDashboard/RecordingLookUpData';
import RecordingLookUpOverview from '../../components/adminDashboard/RecordingLookUpOverview';
import RecordingLookUpSearch from '../../components/adminDashboard/RecordingLookUpSearch';
import RecordingLookUpSensors from '../../components/adminDashboard/RecordingLookUpSensors';

export default function RecordingLookUp() {
  return (
    <Box
      display="grid"
      gridTemplateColumns="2fr 5fr"
      gap={4}
      height="100%"
      overflow="hidden"
    >
      <RecordingLookUpSearch />

      <Box rowGap="0.75rem" display="grid" overflow="auto">
        <RecordingLookUpOverview />
        <RecordingLookUpData />
        <RecordingLookUpSensors />
      </Box>
    </Box>
  );
}
